<!--
 * @Description: 搜索框及选择日期会场部分
 * @Author: 山淑兰
 * @Date: 2019-11-26 14:39:07
 * @LastEditTime: 2020-06-23 12:52:43
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="search">
    <div class="schedule-con">
      <div class="search">
        <input
          type="text"
          :placeholder="$t('meeting.header.search.placeholder')"
          class="search-inp"
          v-model="searchKeyword"
        />
        <div class="search-btn" @click="search()">
          <van-icon name="search" />
        </div>
        <div class="language" v-if="languageShow">
          <span @click="changeLocale('zh-CN')">中文</span>
          |
          <span @click="changeLocale('en-US')">EN</span>
        </div>
      </div>
      <div class="selection">
        <template v-if="$i18n.locale === 'zh-CN'">
          <div class="select">
            <div class="dataTime">
              <div class="swiper-wrapper">
                <div class="swiper-slide"
                  v-for="(item,index) in datas.timeList"
                  :key="item.value"
                  :class="{ blue:index==current}"
                  :id="'nav' + index" v-trigger="index==current"
                  @click="chooseItem_clickHandler(index,item,'times',$event,true)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>

            <ul class="timeData addressData">
              <li
                v-for="(item,index) in datas.addressList"
                :key="item.value"
                :class="{ blue1:index==current1}"
                @click="chooseItem_clickHandler(index,item,'address',$event)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <van-popup
            v-model="flags.isShow"
            position="right"
            class="list-popup"
            :overlay-style="{ background: 'rgba(255,255,255,0.7)' }"
          >
            <ul v-if="flags.type === 'times'">
              <li
                v-for="item in datas.timeList"
                :key="item.value"
                @click="chooseItem_clickHandler(item)"
              >
                {{ item.name }}
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="item in datas.addressList"
                :key="item.value"
                @click="chooseItem_clickHandler(item)"
              >
                {{ item.name }}
              </li>
            </ul>
          </van-popup>
        </template>
        <template v-else>
          <div class="select">
            <div class="dataTime">
              <div class="swiper-wrapper">
                <div class="swiper-slide"
                  v-for="(item,index) in datas.timeList"
                  :key="item.value"
                  :class="{ blue:index==current}"
                  :id="'nav' + index" v-trigger="index==current"
                  @click="chooseItem_clickHandler(index,item,'times',$event,true)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>

            <ul class="timeData addressData">
              <li
                v-for="(item,index) in datas.addressList"
                :key="item.value"
                :class="{ blue1:index==current1}"
                @click="chooseItem_clickHandler(index,item,'address',$event)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <van-popup
            v-model="flags.isShow"
            position="right"
            class="list-popup"
            :overlay-style="{ background: 'rgba(255,255,255,0.7)' }"
          >
            <ul v-if="flags.type === 'times'">
              <li
                v-for="item in datas.timeList"
                :key="item.value"
                @click="chooseItem_clickHandler(item)"
              >
                {{ item.name }}
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="item in datas.addressList"
                :key="item.value"
                @click="chooseItem_clickHandler(item)"
              >
                {{ item.name }}
              </li>
            </ul>
          </van-popup>
        </template>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'searchnew',
  props: ['pupopData','languageShow'],
  data() {
    return {
      m: '',
      roomid: '',
      language: '',
      searchKeyword: '', // 搜索框的值
      // 选择按钮初始值
      labels: {
        times: '',
        address: '',
      },
      //  分辨两个按钮
      flags: {
        type: 'address',
        isShow: false,
      },
      datas: {
        // 弹出框两种数据
        timeList: [],
        addressList: [],
      },
      dateid: '',
      current: -1,
      current1: -1,
    }
  },
  watch: {
    pupopData: {
      handler() {
        this.datas.timeList = this.pupopData
        console.log(this.pupopData)
        if( this.dateid != undefined ){
          for( let i in this.datas.timeList){
            if( this.datas.timeList[i].value == this.dateid ){
              this.current = i
              this.chooseItem_clickHandler(this.current,this.datas.timeList[i],'times','',false)
            }
			if (this.language == 1){
				for (let i in this.datas.timeList) {
					//console.log(this.datas.timeList[i].name)
					if (this.datas.timeList[i].name == '全部日期') {
						this.datas.timeList[i].name = 'All Dates'
					}else if(this.datas.timeList[i].name.indexOf('月')!=-1){
						this.datas.timeList[i].name = this.datas.timeList[i].name.replace('月','.')
					}else if(this.datas.timeList[i].name.indexOf('日')!=-1){
						this.datas.timeList[i].name = this.datas.timeList[i].name.replace('日',' ')
					}
				}
			}
          }
        }else{
          this.current = 0
        }

        this.swiperInit()
      },
    },
  },
  directives:{
    trigger:{
     inserted(el, binging, index){
        //el.click()
      }
    }
  },
  created() {
    let { m, roomid,dateid,language} = this.$route.query
    this.dateid = dateid
    this.m = m
    this.language = language
    
    if( roomid ){
      this.roomid = roomid
    }else{
      this.current1 = -1
    }
    if( this.language == 0 ){
    	this.$i18n.locale = 'zh-CN'
    }else if( this.language == 1 ){
    	this.$i18n.locale = 'en-US'
    }
  },
  mounted(){
    this.swiperInit()
  },
  methods: {
    swiperInit() {
      this.$nextTick(function() {
        var navSwiper = new Swiper('.dataTime', {
          observer: true, 
          observeParents: true,
          freeMode: true,
          slidesPerView: 'auto',
          freeModeSticky: true,
        })
      })
    },
    //中英文切换
    changeLocale(type) {
      this.$i18n.locale = type
	  if( type == 'zh-CN'){
		//this.language = 'cn'  
	  }else if( type == 'en-US' ){
		//this.language = 'en'  
	  }
    },
    //点击弹出右侧弹出层
    chooseTab_clickHandler(type) {
      this.flags.type = type //  按钮的值传给中间件
      if (type === 'address') {
        if (this.datas.addressList.length > 0) {
          this.flags.isShow = true
        }
      } else {
        this.flags.isShow = true
      }
    },
    //  点击右侧弹出层中的列表
    chooseItem_clickHandler(index,data,flag,event,jump) {
      const { type } = flag
      this.flags.isShow = false
      if (flag === 'times') {
        this.current1 = -1;
        this.current=index;
        this.datas.addressList = data.child
        this.datas.addressList.shift()
        // 将dateid 传入到roomList中
        const dateid = data.value
        this.dateid = data.value
        this.labels.address = '' //选择日期后，将会场按钮字段改为‘选择会场’
        let {roomid } = this.$route.query
        this.roomid = roomid
        //console.log(this.roomid)
        if( this.roomid ){
          for( let i in this.datas.addressList){
            if( this.datas.addressList[i].value == this.roomid ){
              this.current1 = i
            }
          }
        }
        if( jump ){
          this.toLinkList('place', { dateid, language: this.language })
        }
      } else {
        this.current1=index;
        const roomid = data.value
        console.log(roomid)
        if (roomid == 0) {
          this.toLinkList('place', { dateid: this.dateid, language: this.language})
        } else {
          this.toLinkList('scheduleList', { roomid, dateid: this.dateid, language: this.language })
        }
      }
      this.labels[type] = data.name //  点击日期或会场列表后，改变按钮的值
    },

    /**
     * @description 跳转页面
     */
    toLinkList(path, params) {
      const m = this.m
      this.$router.push({
        path: '/meeting/' + path,
        query: { m, ...params },
      })
    },
    /**
     * @description 搜索
     */
    search() {
      const m = this.m
      if (this.searchKeyword !== '') {
        let search = this.searchKeyword

        this.$router.push({
          path: '/meeting/searchList',
          query: { m, search, language: this.language },
        })
      } else {
        this.$router.push({
          path: '/meeting/place',
          query: { m, language: this.language},
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
* {
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}
.schedule-con {
  overflow-x: hidden;
  .search {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    .search-inp {
      border-radius: 0;
      flex: 1;
      height: 74px;
      font-size: 28px;
      padding: 0 20px;
      border: 1px solid #e2e8f0;
      background: #fff;
      border-radius: 42px 0 0 42px;
    }
    .search-btn {
      width: 78px;
      height: 74px;
      background: #3b82f6;
      text-align: center;
      border-radius: 0 42px 42px 0;
      .van-icon {
        color: #fff;
        font-size:28px;
        padding-top: 24px;
      }
    }
    .language {
     font-size:28px;
      text-align: center;
      line-height: 40px;
      margin: 20px;
    }
  }
  .selection {
    width: 100%;
    padding: 20px 0 0;
    display: flex;
    background: #fff;
    margin-bottom: 6px;
    .select{
      width: 100%;
      font-size: 28px;
      .dataTime{
        width: 100%;
        
        padding-bottom: 20px;
        border-bottom: 1px solid #e2e8f0;
        .swiper-slide {
          padding:0 20px;
          width:auto;
        }
        .blue{
          position: relative;
          color: #3b82f6;
        }
        .blue:after{
          position: absolute;
          display: block;
          content: '';
          height: 3px;
          left: 0;
          right: 0;
          bottom: -21px;
          width: 100%;
          background: #3b82f6;
        }
      }
      .timeData{
        width: 100%;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        padding: 0 20px;
        margin-top: 20px;
        li{
          width: 25%;
          text-align: center;
          margin-bottom: 15px;
        }
      }
      .addressData{
        li{
          width: 33.3%;
          padding: 5px 20px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .blue1{
          background: #3b82f6;
          color: #fff;
        }
      }
    }
    .select-date,
    .select-space {
      flex: 1;
      text-align: center;
      line-height: 88px;
     font-size:28px;
      border-bottom: 1px solid #e2e8f0;
      border-top: 1px solid #e2e8f0;
      position: relative;
      .arrow {
        position: absolute;
        right: -1px;
        bottom: -6px;
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid #3b82f6;
        vertical-align: middle;

        transform: rotate(45deg);
      }
    }
    .select-date {
      border-right: 1px solid #e2e8f0;
    }
    .list-popup {
      width: 48%;
      height: 100%;
      background: #1e293b;
      font-size: 28px;
      ul {
        li {
          color: #fff;
          border-bottom: 1px solid #1e293b;
          padding: 20px 10px;
        }
      }
    }
  }
}
</style>
